module.exports = __webpack_public_path__ + "img/pic38.cdc56916.png";